export default __webpack_public_path__ + "static/media/back.60685657.svg";